import React from 'react';

export type BackdropType = 'type-a' | 'type-b' | 'type-c' | 'type-d' | 'type-e';

export interface RasterGridBackdropProps {
  type?: BackdropType;
  showTicks?: boolean;
  showContours?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const RasterGridBackdrop: React.FC<RasterGridBackdropProps> = ({
  className = '',
  children,
}) => {
  const hasPos = className.includes('absolute') || className.includes('fixed') || className.includes('relative');
  const defaultPos = children ? 'relative w-full' : 'absolute inset-0 pointer-events-none z-0';
  return (
    <div className={`${hasPos ? '' : defaultPos} overflow-hidden bg-[#05070A] ${className}`}>
      {/* Faint Hairline Grid (Zero color bleeds, zero numbers, zero contour noise) */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `
            linear-gradient(to right, #262C31 1px, transparent 1px),
            linear-gradient(to bottom, #262C31 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px',
        }}
      />
      {children && <div className="relative z-10">{children}</div>}
    </div>
  );
};

export default RasterGridBackdrop;

